import React from 'react';
import './App.css';

import { QueryClient, QueryClientProvider } from 'react-query'
import { ThemeModeProvider } from './theme/ThemeModeProvider';

const queryClient = new QueryClient()
function App({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeModeProvider>
        <div className="App">
          {children}
        </div>
      </ThemeModeProvider>
    </QueryClientProvider>
  );
}

export default App;
